import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro'
import React from 'react'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
// import 'dayjs/locale/th';
import buddhistEra from "dayjs/plugin/buddhistEra";
dayjs.extend(buddhistEra);
dayjs.locale("th");

function CustomDatePicker(props) {

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="th"
            dateFormats={{ monthAndYear: 'MMMM BBBB', year: 'BBBB' }}
            localeText={{
                calendarWeekNumberText: (weekNumber) => `${weekNumber}.`,
            }}
        >
            <DemoContainer components={['DatePicker']}>
                <DatePicker
                    {...props}
                    dayOfWeekFormatter={(_day, weekday) => `${weekday.format('dd')}`}
                    // slotProps={{
                    //     textField: { size: 'small', inputProps: { value: props?.value ? `${props?.value.format('DD/MM/BBBB')}` : null } },
                    // }}
                />
            </DemoContainer>
        </LocalizationProvider>
    )
}

export default CustomDatePicker